import "./App.css";

import {
  ActionButton,
  Body,
  Divider,
  IBoardStyle,
  InstallableContainer,
  MessagePreviewModal,
  NotificationBanner,
  Spacer,
  SubTitle,
  Theme,
  encodeBoardCharacters,
} from "@vestaboard/installables";
import '@vestaboard/installables/lib/utils/loadAssets';
import React, { useState } from "react";
import {
  Route,
  BrowserRouter as Router,
  Routes,
  useLocation,
} from "react-router-dom";

import { Box } from "@mui/material";
import { MirrorInstallableSettings } from "./MirrorInstallableSettings";
import { QueryParamProvider } from "use-query-params";

function App() {
  return (
    <Theme>
      <QueryParamProvider>
        <Router>
          <Routes>
            <Route path="/default-config" element={<DefaultConfig />} />
            <Route path="/settings">
              <Route path="mirror" element={<MirrorInstallableSettings />} />
            </Route>
            <Route path="/installable">
              <Route path="mirror">
                <Route
                  path="settings"
                  element={<MirrorInstallableSettings />}
                />
              </Route>
            </Route>
          </Routes>
        </Router>
      </QueryParamProvider>
    </Theme>
  );
}

interface IConfig {
  requiresConfiguration: boolean;
  setupMessage?: string;
  setupBody?: string;
  setupCtaUrl?: string;
  confirmedBody?: string;
  confirmedMessage?: string;
  setupCtaLabel?: string;
  quietHours?: string;
  boardStyle?: string;
  notePreviewMessage?: string;
  previewMessage?: string;
  isNote?: boolean;
}

// If this than that uses this component
const DefaultConfig: React.FC = (props) => {
  const { search } = useLocation();
  const [openPreview, setOpenPreview] = useState(false);

  let config: IConfig | null = null;

  try {
    config = JSON.parse(atob(search.substring(1).split("&")[0]));
  } catch (e) {
    config = null;
  }
  if (!config) return <span />;
  // IFTTT
  return (
    <>
      <Box
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          height: "100vh",
          padding: 16,
          paddingTop: 32,
          backgroundColor: "#25282a",
        }}
      >
        <Box
          style={{
            textAlign: "left",
            width: "100%",
            maxWidth: 600,
          }}
        >
          {config?.quietHours ? (
            <InstallableContainer>
              <Spacer size="medium" />
              <div style={{}}>
                <NotificationBanner
                  visible={true}
                  text={config.quietHours || ""}
                />
              </div>
              <Spacer size="medium" />
            </InstallableContainer>
          ) : null}
          <SubTitle>Description</SubTitle>
          <Spacer size="medium" />
          <Body>
            Receive automated messages from your favorite third-party services
            by linking Vestaboard to your IFTTT account. This channel connects
            to a third party website.
          </Body>
          <Spacer size="medium" />
          <Box style={{ display: "flex", flexDirection: "row" }}>
            <ActionButton
              onClick={() => {
                setOpenPreview(true);
              }}
            >
              Preview
            </ActionButton>
            <div style={{ width: 16 }}></div>
            <ActionButton
              onClick={() => {
                window.open("https://www.vestaboard.com/help/ifttt");
              }}
            >
              Help
            </ActionButton>
          </Box>
          <Spacer size={"large"} />
          <Divider />
          <Spacer size={"large"} />
          <SubTitle>
            {config.requiresConfiguration
              ? "Authorization Needed"
              : "Authorization Complete"}
          </SubTitle>
          <Spacer size="medium" />
          <Body>
            {config.requiresConfiguration
              ? "To begin using IFTTT with your Vestaboard, we’ll need you to authorize access to your IFTTT account first. Click the button below to start the process or create a free account today."
              : "You have authorized this Vestaboard to be used with IFTTT. Visit IFTTT to manage."}
          </Body>
          <Spacer size="extraLarge" />
          {!!config.setupCtaUrl && (
            <>
              <a
                href={config.setupCtaUrl}
                rel="noopener noreferrer"
                target="_blank"
                className="button-link full-width"
              >
                {config.requiresConfiguration
                  ? "Authorize IFTTT"
                  : "Manage IFTTT"}
              </a>
            </>
          )}
        </Box>
      </Box>
      <MessagePreviewModal
        visible={openPreview}
        onClose={function (): void {
          setOpenPreview(false);
        }}
        boardStyle={config?.boardStyle as IBoardStyle}
        characters={
          config.isNote
            ? config.notePreviewMessage
              ? JSON.parse(config.notePreviewMessage)
              : encodeBoardCharacters(
                  `Dad is almost home!   Head to the garage.`
                )
            : config.previewMessage
            ? JSON.parse(config.previewMessage)
            : encodeBoardCharacters(
                `                                             Dad is almost home!   Head to the garage.`
              )
        }
      />
    </>
  );
};

export default App;
